<template>
  <aside class="main-sidebar sidebar-light-lightblue elevation-2">
    <router-link :to="'/admin/home'" title="SiTrendi">
      <img
        :src="app_logo"
        alt="SiTrendi - Sistem Pesantren Digital"
        class="brand-image"
        style="opacity: 0.8; width: 160px; margin: 5px 40px -8px 40px"
      />
    </router-link>
    <hr />

    <div class="sidebar">
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false"
        >
          <li
            v-for="(permission, index) in permissions"
            :key="index"
            :class="
              'nav-item ' +
              index +
              (permission.permissions.length > 0 && currentSelection === index
                ? ' menu-is-opening menu-open'
                : '')
            "
            @click="toogleItem(index)"
          >
            <router-link
              :to="permission.permissions.length > 0 ? '#' : permission.slug"
              :title="permission.name"
              :class="'nav-link' + (currentSelection === index ? ' active' : '')"
            >
              <i :class="'nav-icon ' + permission.icon"></i>
              <p>
                {{ permission.name }}
                <i v-if="permission.permissions.length > 0" class="right fas fa-angle-left"></i>
              </p>
            </router-link>
            <ul
              v-if="permission.permissions.length > 0"
              v-show="currentSelection === index"
              class="nav nav-treeview"
            >
              <li
                v-for="(child, childindex) in permission.permissions"
                :key="index.toString() + childindex.toString()"
                :class="'nav-item ' + index.toString() + childindex.toString()"
                @click="toogleSubItem(index.toString() + childindex.toString())"
              >
                <router-link
                  :id="child.permission_id"
                  :to="child.slug"
                  :class="
                    'nav-link' +
                    (currentSelectionSub === index.toString() + childindex.toString()
                      ? ' active'
                      : '')
                  "
                >
                  <i class="far fa-circle nav-icon"></i>
                  <p>
                    {{ child.name }}
                  </p>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
// Utilities
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  middleware: 'auth',
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      app_logo: process.env.appLogo,
      activeLink: this.$route.path,
      currentSelection: '',
      currentSelectionSub: 0,
      permissions: [],
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'loggedInUser']),
    ...mapState('app', ['image', 'color']),
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
    inputValue: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.setDrawer(val)
      },
    },
  },
  mounted() {
    this.permissions = this.loggedInUser?.permissions

    for (let i = 0; i < this.permissions.length; i++) {
      if (this.permissions[i].slug === this.$route.path) {
        this.permissions[i].active = true
        this.currentSelection = i
      } else {
        this.permissions[i].active = false
      }
      if (this.permissions[i].permissions.length > 0) {
        for (let j = 0; j < this.permissions[i].permissions.length; j++) {
          if (this.permissions[i].permissions[j].slug === this.$route.path) {
            this.permissions[i].permissions[j].active = true
            this.currentSelectionSub = i.toString() + j.toString()
          } else {
            this.permissions[i].permissions[j].active = false
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    toogleItem(index) {
      this.currentSelection = index
      if (this.permissions[index].permissions.length === 0) {
        this.currentSelectionSub = 0
      }
    },
    toogleSubItem(childIndex) {
      this.currentSelectionSub = childIndex
    },
  },
}
</script>

<style scoped>
[class*='sidebar-dark-'] {
  background-color: #1b3d60;
}
</style>
